<style src='@/resources/styles/results.css' scoped></style>

<template>
    <div class='health-wrapper show'>
        <div class='health-inner'>
            <div class='health-character'></div>
            <div class='health-bar-wrapper'>
                <!--
                  Changing bar-max to bar-low changes colors from green to orange, and setting the bar style's width to 0 will make the bar completely red.
                -->
                <div class='health-bar'
                     :class="{bar_max: isMax, bar_med: isMed, bar_low: isLow}"
                :style="{width: percent}"></div>
            </div>
            <div class='health-points'>{{credits.remaining}} / {{credits.total}}</div>
            <button class='health-recharge-button' @click="recharge"
                    :class="{animated: animating, flash: animating}">Recharge</button>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'HealthBar',
      computed: {
          ...mapGetters(['state', "loadingStatus", "loadingProgress", "filters", 'credits', 'proj']),


        percentRaw() {
            return Math.ceil(( this.credits.remaining / this.credits.total ) * 100);
        },

        percent() {
            return this.percentRaw + "%";
        },

        isMax() {
            return this.percentRaw >= 40;
        },

        isMed() {
            return false //! this.isMax && this.percentRaw >= 40;
        },

        isLow() {
            return ! this.isMax;
        }

      },

    data() {
      return {
        animating: false
      }
    },
    methods: {
      flash() {
        this.animating = true;
      },

      noFlash() {
        this.animating = false;
      },


      recharge() {
        this.$router.push(`/recharge/${this.proj.slug}`)
      }
    }
  }
</script>